import React from "react";
import { useState, useEffect } from "react";
import {
  BarChartWithXValuesRotate,
  IGroupedData,
} from "../Charts/BarChartWithXValuesRotate";

import { useGlobalState } from "../Context/GlobalStateContext";
import AppContext from "../Context/Context";
import axiosAuth from "../Axios/Interceptors";
import { DownloadClientsDataInExcel, getAcademicYear } from "../Shared/Utility";
import LoadingAnimation from "../LoadingAnimation/LoadingAnimation";
import TabFilter from "../App/TabFilter";
import { ManagementSummaryNamePlate } from "../Charts/ManagementSummaryNamePlate";
import { BarChartWithLine } from "../Charts/BarChartWithLine";
import DonutChart from "../Charts/DonutChart";
import { IGroupedDataWithClick } from "../Charts/BarChartGlobalReportingForecast";
import {
  GroupedStackedChart,
  IGroupedDataCombined,
} from "../Charts/GroupedStackedChart";
import Header from "../App/Header";
export function ProgramOverview() {
  const globalState = useGlobalState();
  const [showAnimation, setShowAnimation] = useState(false);

  const [programList, setProgramList] = useState<any>([]);
  const [quarterList, setQuarterList] = useState<any>([]);
  const [groupList, setGroupList] = useState<any>([]);
  const [loadGraph, setLoadGraph] = useState(false);
  const [dashboardData, setDashboardData] = useState<any>([]);
  const [isSingleImporter, setIsSingleImporter] = useState(false);
  const [LoadDashboardSummary, setLoadDashboardSummary] = useState(false);
  const [selectedSummaryObject, setselectedSummaryObject] = useState({
    POT: 0,
    FinalPayout: 0,
    FinalPayoutPercentage: 0,
    ConditionalHoldInPending: 0,
    ConditionalHoldInPendingPercentage: 0,
  });

  const [BarChartDATA, setBarChartDATA] = useState<IGroupedData[]>([]);
  const [quarterData, setQuarterData] = useState<any>([]);
  const [payoutPerCriteriaData, setPayoutPerCriteriaData] = useState<any>([]);
  const [BarChartDataWithLine, setBarChartDataWithLine] = useState<
    IGroupedData[]
  >([]);
  const [lineDataNumbers, setlineDataNumbers] = useState<[number, number][]>(
    []
  );
  const [loadStackedBarChart, setLoadStackedBarChart] = useState(false);

  const [Legends, setLegends] = useState([""]);
  const [Legends3, setLegends3] = useState([""]);
  const [BarChartDATA2, setBarChartDATA2] = useState<IGroupedData[]>([]);
  const [Legends2, setLegends2] = useState([""]);
  const [yoyGrowth, setYoyGrowth] = useState<any>([]);
  const [yoyGrowthImporter, setYoyGrowthImporter] = useState<any>([]);
  const colorsForBars = [
    "#336699",
    "#E8AB59",
    "#D8DDE0",
    "#D1DB82",
    "#E2D4CB",
    "#D6EDF6",
    "#A6C3C1",
    "#D2AA87",
    "#B9e8f1",
    "#274b63",
    "#46d39a",
    "#64b5f6",
    "#BFE8FF",
    "#0075A4",
    "#FFB996",
    "#7BD3EA",
    "#B0A695",
    "#8EACCD",
  ];

  let filterArray = [
    { Name: "Table View", ID: 0, Title: "Table View" },
    { Name: "Graphical View", ID: 1, Title: "Graphical View" },
  ];

  const [tabFilterObject, setTabFilterObject] = useState({
    View: 0,
  });

  const [payOutTableData, setPayOutTableData] = useState<any>({
    Header: [
      {
        FundAvailable: "Fund Available",
        AchievedPercentage: "% Quarter Result",
        AchievedUSD: "$ Quarter Result",
      },
      {
        FundAvailable: "Fund Available",
        AchievedPercentage: "% Quarter Result",
        AchievedUSD: "$ Quarter Result",
      },
      {
        FundAvailable: "Fund Available",
        AchievedPercentage: "% Quarter Result",
        AchievedUSD: "$ Quarter Result",
      },
      {
        FundAvailable: "Fund Available",
        AchievedPercentage: "% Quarter Result",
        AchievedUSD: "$ Quarter Result",
      },
      {
        FundAvailable: "Fund Available",
        AchievedPercentage: "% Quarter Result",
        AchievedUSD: "$ Quarter Result",
      },
    ],
    GridData: [],
  });

  const [payOutHistoryAccord, setPayOutHistoryAccord] = useState(false);
  const [payOutPerCriteriaAccord, setPayOutPerCriteriaAccord] = useState(false);
  const [payOutTARGETSPerCriteriaAccord, setPayOutTARGETSPerCriteriaAccord] =
    useState(false);

  const [dashoardDataFilter, setDashoardDataFilter] = useState({
    ProgramID: globalState.TopFilterData.IBBProgramID,
    QuarterID: 0, // globalState.TopFilterData.QuarterID,
    PFIGroupIDs: "1",
    PFIBrandID: 2,
  });

  useEffect(() => {
    const search = window.location.search;
    const params = new URLSearchParams(search);

    let QuarterID = params.get("qid") as any;
    if (QuarterID && QuarterID != "") QuarterID = Number(QuarterID);
    else QuarterID = dashoardDataFilter.QuarterID;

    let IBBProgramID = params.get("pid") as any;
    if (IBBProgramID && IBBProgramID != "") IBBProgramID = Number(IBBProgramID);
    else IBBProgramID = dashoardDataFilter.ProgramID;

    setDashoardDataFilter((prevState: any) => ({
      ...prevState,
      ProgramID: IBBProgramID,
      QuarterID: QuarterID,
    }));

    IBBProgramGetProgramListForScorecard(IBBProgramID, QuarterID);
    IBBGroupGetCompleteGridData();
  }, []);
  useEffect(() => {
    if (dashoardDataFilter.ProgramID > 0) IBBProgramGetDataForMainDashboard();
  }, [dashoardDataFilter]);

  function IBBProgramGetProgramListForScorecard(
    IBBProgramID: number,
    QuarterID: number
  ) {
    if (IBBProgramID == 0) IBBProgramID = dashoardDataFilter.ProgramID;
    let object = {} as any;
    object.appid = AppContext.App;
    object.isdeleted = false;
    object.ibbprogramid = IBBProgramID;
    object.numericquarter = dashoardDataFilter.QuarterID;
    setShowAnimation(true);
    axiosAuth
      .post(
        AppContext.AppBaseURL +
          "api/IBBProgram/IBBProgramGetProgramListForScorecard",
        object
      )
      .then((response) => {
        setShowAnimation(false);
        if (response.data.Status == 1) {
          let result = response.data.Data;
          if (result.length > 1 && result[0].length > 0) {
            setProgramList(result[0]);
            if (IBBProgramID == 0) {
              IBBProgramID = result[0][0].IBBProgramID;
              setDashoardDataFilter((prevState: any) => ({
                ...prevState,
                ProgramID: IBBProgramID,
              }));
            }
          }

          setQuarterList(result[2]);
          // if (QuarterID == 0) {
          //   let QuarterID = result[2][0].PID;
          //   setDashoardDataFilter((prevState: any) => ({
          //     ...prevState,
          //     QuarterID: QuarterID,
          //   }));
          // }
        } else {
          AppContext.ShowNotification("error", response.data.Message);
        }
      })
      .catch((error) => {
        console.error("There was an error!", error);
      });
  }

  function IBBGroupGetCompleteGridData() {
    let object = {} as any;
    object.appid = AppContext.App;
    object.isdeleted = false;
    object.recordsperpage = 1000;
    object.sortexpressions = "Description";
    object.sortdirection = "D";
    setShowAnimation(true);
    axiosAuth
      .post(
        AppContext.AppBaseURL + "api/IBBGroup/IBBGroupGetCompleteGridData",
        object
      )
      .then((response) => {
        setShowAnimation(false);
        if (response.data.Status === 1) {
          let result = response.data.Data;
          if (result.length > 1) {
            if (result[1].length > 0) {
            }

            setGroupList(result[1]);
          }
        } else {
          AppContext.ShowNotification("error", response.data.Message);
        }
      })
      .catch((error) => {
        console.error("There was an error!", error);
      });
  }
  function IBBProgramGetDataForMainDashboard() {
    let object = {} as any;
    object.appid = AppContext.App;
    object.ibbprogramid = dashoardDataFilter.ProgramID;
    object.quarterid = dashoardDataFilter.QuarterID;
    object.pfibrandid = dashoardDataFilter.PFIBrandID;
    object.pfigroupids = dashoardDataFilter.PFIGroupIDs;
    setShowAnimation(true);
    axiosAuth
      .post(
        AppContext.AppBaseURL +
          "api/IBBProgram/IBBProgramGetDataForMainDashboard",
        object
      )
      .then((response) => {
        setShowAnimation(false);
        if (response.data.Status === 1) {
          let result = response.data.Data;
          setDashboardData(result);
          
          if (result[0] != null) {
            HandleMonthlySplitData_Mena(result[0], result[6]);
          }
          if (result[1] != null) {
            MakeYearPOTDataWithLine(result[1]);
          }
          if (result[2] != null) {
            MakeImporterLevelPOTData(result[2]);
          }

          if (result[5] != null && result[5].length > 0) {
            setIsSingleImporter(
              result[5][0]["IsImporterView"] == 1 ? true : false
            );
            if (result[6]) {
              setQuarterData(result[6]);
            }
          }

          if (result[8] != null) {
            let payoutHeader = [...payOutTableData["Header"]];
            let payoutGrid = result[8];

            var filtered = payoutGrid.filter(
              (item: any) => item.Q1ShowYellowColor == "OrangeClass"
            );
            if (filtered.length > 0) {
              payoutHeader[0]["AchievedPercentage"] = "% Final Achievement";
              payoutHeader[0]["AchievedUSD"] = "$ Final Achievement";

              payoutHeader[4]["AchievedPercentage"] = "% Final Achievement";
              payoutHeader[4]["AchievedUSD"] = "$ Final Achievement";
            }

            filtered = payoutGrid.filter(
              (item: any) => item.Q2ShowYellowColor == "OrangeClass"
            );
            if (filtered.length > 0) {
              payoutHeader[1]["AchievedPercentage"] = "% Final Achievement";
              payoutHeader[1]["AchievedUSD"] = "$ Final Achievement";

              payoutHeader[4]["AchievedPercentage"] = "% Final Achievement";
              payoutHeader[4]["AchievedUSD"] = "$ Final Achievement";
            }

            filtered = payoutGrid.filter(
              (item: any) => item.Q3ShowYellowColor == "OrangeClass"
            );
            if (filtered.length > 0) {
              payoutHeader[2]["AchievedPercentage"] = "% Final Achievement";
              payoutHeader[2]["AchievedUSD"] = "$ Final Achievement";

              payoutHeader[4]["AchievedPercentage"] = "% Final Achievement";
              payoutHeader[4]["AchievedUSD"] = "$ Final Achievement";
            }

            filtered = payoutGrid.filter(
              (item: any) => item.Q4ShowYellowColor == "OrangeClass"
            );
            if (filtered.length > 0) {
              payoutHeader[3]["AchievedPercentage"] = "% Final Achievement";
              payoutHeader[3]["AchievedUSD"] = "$ Final Achievement";

              payoutHeader[4]["AchievedPercentage"] = "% Final Achievement";
              payoutHeader[4]["AchievedUSD"] = "$ Final Achievement";
            }

            let payoutHistoryData = {
              Header: payoutHeader,
              GridData: payoutGrid,
            };
            setPayOutTableData(payoutHistoryData);
          }
        } else {
          AppContext.ShowNotification("error", response.data.Message);
        }
      })
      .catch((error) => {
        console.error("There was an error!", error);
      });
  }
  const [
    GROUPED_BAR_CHART_DATA_Stock_Mena,
    setGROUPED_BAR_CHART_DATA_Stock_Mena,
  ] = useState<IGroupedDataCombined[]>([]);

  const [LoadChart3, setLoadChart3] = useState(false);
  function HandleMonthlySplitData_Mena(objVolumChartData: any, quarters: any) {
    // setlineDataNumbers_Mena([]);
    setGROUPED_BAR_CHART_DATA_Stock_Mena([]);

    var l_DataVolumeTotal: any = [];
    var l_legends = [];
    var lineData: any = [];

    var colors1: any = colorsForBars;

    var colors2: any = colorsForBars;
    for (let index = 0; index < quarters.length; index++) {
      const element = quarters[index];
      if (element.Name != "YTD") l_legends.push(element.Name);
    }
    // l_legends.push("Q1", "Q2", "Q3", "Q4");

    for (var k = 0; k < objVolumChartData.length; k++) {
      let itemLabel = objVolumChartData[k].FYText;

      var bars = [];
      var itemValueHOB = [];
      var itemValueHOB2 = [];

      let item = objVolumChartData[k];
      for (let index = 0; index < objVolumChartData.length; index++) {
        const element = objVolumChartData[index];

        if (element.FYText == itemLabel) {
          //  var linevalue = item["STTrend"];
          //    lineData.push([index, linevalue]);
          var value1 = element["POT"];

          itemValueHOB.push(value1);
          var value11 = element["FinalPayout"];

          itemValueHOB2.push(value11);
        }
      }
      bars.push({
        index: 0,
        BarData: itemValueHOB,

        colors: colors1,
        legendsHOB: l_legends,
      });

      bars.push({
        index: 1,
        BarData: itemValueHOB2,
        legendsHOB: l_legends,

        colors: colors2,
      });
      l_DataVolumeTotal.push({
        label: itemLabel,
        values: bars,
      });
    }
    setGROUPED_BAR_CHART_DATA_Stock_Mena(l_DataVolumeTotal);

    if (l_DataVolumeTotal.length > 0) setLoadChart3(true);
  }
  function MakeYearPOTDataWithLine(objVolumChartData: any) {
    var l_DataFinanceTotalHOB = [];
    var yoyGrowth = [];
    setlineDataNumbers([]);
    var lineData: any = [];
    var index = 1;

    for (var i = 0; i < objVolumChartData.length; i++) {
      let item = objVolumChartData[i];
      let itemLabel = item["IBBProgramSectionName"];
      var itemValueHOB = [];

      var value = item["POT"];
      itemValueHOB.push(value);
      var value2 = item["FinalPayout"];
      itemValueHOB.push(value2);
      yoyGrowth.push(item["FinalPayoutPercentage"]);
      l_DataFinanceTotalHOB.push({
        label: itemLabel,
        values: itemValueHOB,
      });
      var linevalue = item["FinalPayoutPercentage"];

      lineData.push([index, linevalue]);
      index++;
    }
    setLegends3(["Funds available", "Achievement"]);

    setlineDataNumbers(lineData);
    setBarChartDataWithLine(l_DataFinanceTotalHOB);
    setLoadGraph(true);
  }
  function MakeYearPOTData(objVolumChartData: any) {
    var l_DataFinanceTotalHOB = [];
    var yoyGrowth = [];
    for (var i = 0; i < objVolumChartData.length; i++) {
      let item = objVolumChartData[i];
      let itemLabel = item["FYText"];
      var itemValueHOB = [];

      var value = item["POT"];
      itemValueHOB.push(value);
      var value2 = item["FinalPayout"];
      itemValueHOB.push(value2);
      yoyGrowth.push(item["FinalPayoutPercentage"]);
      l_DataFinanceTotalHOB.push({
        label: itemLabel,
        values: itemValueHOB,
      });
    }
    setLegends(["Funds available", "Achievement"]);
    setYoyGrowth(yoyGrowth);
    setBarChartDATA(l_DataFinanceTotalHOB);
  }
  function MakeImporterLevelPOTData(objVolumChartData: any) {
    var l_DataFinanceTotalHOB = [];
    var yoyGrowth = [];
    for (var i = 0; i < objVolumChartData.length; i++) {
      let item = objVolumChartData[i];
      let itemLabel = item["DealerName"];
      var itemValueHOB = [];

      var value = item["POT"];
      itemValueHOB.push(value);
      var value2 = item["FinalPayout"];
      itemValueHOB.push(value2);

      yoyGrowth.push(item["FinalPayoutPercentage"]);
      l_DataFinanceTotalHOB.push({
        label: itemLabel,
        values: itemValueHOB,
      });
    }
    setLegends2(["Funds available", "Achievement"]);
    setYoyGrowthImporter(yoyGrowth);
    setBarChartDATA2(l_DataFinanceTotalHOB);
  }

  function handleTabFilterCallback(TabFilterData: any) {
    let ID = TabFilterData.ID;
    let Type = TabFilterData.Type;
    if (Type === 1) {
      tabFilterObject.View = ID;
      setTabFilterObject((prevState: any) => ({
        ...prevState,
        TypViewe: ID,
      }));
    }
  }
  useEffect(() => {
    if (dashboardData && dashboardData.length > 0)
      formatSectionAndCriteriaInputDataForDetailsScorecard();
  }, [dashboardData]);

  function formatSectionAndCriteriaInputDataForDetailsScorecard() {
    let importerListLocal = [...dashboardData[2]];
    for (let i = 0; i < importerListLocal.length; i++) {
      for (let j = 0; j < dashboardData[1].length; j++) {
        let PFIDealerID = importerListLocal[i].PFIDealerID;
        let IBBProgramSectionID = dashboardData[1][j].IBBProgramSectionID;
        let Title = dashboardData[1][j].IBBProgramSectionName;

        importerListLocal[i][Title + "FundsAvailable"] = "";
        importerListLocal[i][Title + "FinalAchievment"] = "";
        importerListLocal[i][Title + "NonAchieved"] = "";
        importerListLocal[i][Title + "PerFinalAchievment"] = "";

        var filtered = dashboardData[7].filter(
          (item: any) =>
            item.PFIDealerID == PFIDealerID &&
            item.IBBProgramSectionID == IBBProgramSectionID
        );
        if (filtered.length > 0) {
          importerListLocal[i][Title + "FundsAvailable"] = filtered[0].POT || 0;
          importerListLocal[i][Title + "FinalAchievment"] =
            filtered[0].FinalPayout || 0;
          importerListLocal[i][Title + "NonAchieved"] =
            filtered[0].NotAchieved || 0;
          importerListLocal[i][Title + "PerFinalAchievment"] =
            filtered[0].FinalPayoutPercentage || 0;
        }
      }
    }

    setPayoutPerCriteriaData(importerListLocal);
  }
  return (
    <>
      {showAnimation && <LoadingAnimation />}
      <div className="page--contents">
        <div className="page--breadcrumb">
          <a>Program Overview</a>
        </div>
        <div className="page--data">
          <div className="flex-container">
            <div className="flex-items">
              <select
                value={dashoardDataFilter.ProgramID}
                onChange={(e) => {
                  setDashoardDataFilter((prevState: any) => ({
                    ...prevState,
                    ProgramID: Number(e.target.value),
                    QuarterID: 0,
                  }));
                  globalState.setTopFilterData((prevState: any) => ({
                    ...prevState,
                    IBBProgramID: Number(e.target.value),
                    QuarterID: 0,
                  }));
                  IBBProgramGetProgramListForScorecard(
                    Number(e.target.value),
                    0
                  );
                }}
              >
                {programList &&
                  programList.map((item: any, index: any) => (
                    <option value={item.PID} key={"programoption" + item.PID}>
                      {item.Name}
                    </option>
                  ))}
              </select>

              <select
                value={dashoardDataFilter.QuarterID}
                onChange={(e) => {
                  setDashoardDataFilter((prevState: any) => ({
                    ...prevState,
                    QuarterID: Number(e.target.value),
                  }));
                  globalState.setTopFilterData((prevState: any) => ({
                    ...prevState,
                    QuarterID: Number(e.target.value),
                  }));
                }}
              >
                <option value={0} key={"quarteroption" + 0}>
                  YTD
                </option>
                {quarterList &&
                  quarterList.map((item: any, index: any) => (
                    <option value={item.PID} key={"quarteroption" + item.PID}>
                      {item.Name}
                    </option>
                  ))}
              </select>
              <select
                value={dashoardDataFilter.PFIBrandID}
                onChange={(e) =>
                  setDashoardDataFilter((prevState: any) => ({
                    ...prevState,
                    PFIBrandID: Number(e.target.value),
                  }))
                }
              >
                {AppContext.BrandList &&
                  AppContext.BrandList.map((Item: any, index: any) => (
                    <>
                      {
                        <option value={Item.PID} key={"brand" + Item.PID}>
                          {Item.Name}
                        </option>
                      }
                    </>
                  ))}
              </select>

              <select
                value={dashoardDataFilter.PFIGroupIDs}
                onChange={(e) =>
                  setDashoardDataFilter((prevState: any) => ({
                    ...prevState,
                    PFIGroupIDs: Number(e.target.value),
                  }))
                }
              >
                {groupList &&
                  groupList.map((item: any, index: any) => (
                    <option value={item.IBBGroupID} key={"groupoption" + index}>
                      {item.Name}
                    </option>
                  ))}
              </select>

              <TabFilter
                DataType={1}
                SelectedValue={tabFilterObject.View}
                DataList={filterArray}
                TabFilterCallback={handleTabFilterCallback}
              />
            </div>
          </div>

          <div className="q-boxes pg-ov-grid">
            {quarterData &&
              quarterData.map((Item: any, index: any) => (
                <div className="q-box-s" key={"quarterview" + index}>
                  <div className="q-head">{Item.Name}</div>
                  {true && (
                    <div className="pot-fp fix-width-boxes">
                      <div className="re-earn">
                        <span className="re-val1">
                          <span>Funds available</span>
                        </span>
                        <span className="re-val2">
                          $
                          {Item.POT.toLocaleString(undefined, {
                            minimumFractionDigits: 0,
                            maximumFractionDigits: 0,
                          })}
                        </span>
                      </div>
                      <div className="pot-per">
                        <DonutChart
                          data={[
                            {
                              name: "Achieved",
                              value: Number(
                                Item.POT > 0
                                  ? (Item.FinalPayout / Item.POT) * 100
                                  : 0
                              )?.toLocaleString(undefined, {
                                minimumFractionDigits: 2,
                                maximumFractionDigits: 2,
                              }),
                              color: "#98cb4a",
                            },
                            {
                              name: "Not Achieved",
                              value:
                                100 -
                                Number(
                                  Item.POT > 0
                                    ? (Item.FinalPayout / Item.POT) * 100
                                    : 0
                                ),
                              color: "#f5f5f5",
                            },
                          ]}
                          totalValueToPrint={
                            Number(
                              Item.POT > 0
                                ? (Item.FinalPayout / Item.POT) * 100
                                : 0
                            )?.toLocaleString(undefined, {
                              minimumFractionDigits: 2,
                              maximumFractionDigits: 2,
                            }) + "%"
                          }
                          showTextOnGraph={0}
                          innerRadius={1.2}
                        ></DonutChart>
                      </div>

                      <div className="re-earn">
                        <span className="re-val1">Achievement</span>
                        <span className="re-val2">
                          $
                          {Item.FinalPayout.toLocaleString(undefined, {
                            minimumFractionDigits: 0,
                            maximumFractionDigits: 0,
                          })}
                        </span>
                      </div>
                      <div className="excp-left">
                        <div className="excp-1">
                          <img
                            src="images/excp.svg"
                            width="24px"
                            height="24px"
                          />
                          <span>Exceptions</span>
                        </div>
                        <div className="excp-2">
                          <span className="e-y">
                            <a
                              title="View"
                              href={
                                "exceptions?pid=" +
                                dashoardDataFilter.ProgramID +
                                "&qid=" +
                                Item.PID +
                                "&exsid=0"
                              }
                            >
                              {Item.InProgressExceptionCount > 0 && (
                                <>{Item.InProgressExceptionCount}</>
                              )}
                            </a>
                          </span>
                          <span className="e-g">
                            <a
                              title="View"
                              href={
                                "exceptions?pid=" +
                                dashoardDataFilter.ProgramID +
                                "&qid=" +
                                Item.PID +
                                "&exsid=1"
                              }
                            >
                              {Item.ApprovedExceptionCount > 0 && (
                                <>{Item.ApprovedExceptionCount}</>
                              )}
                            </a>
                          </span>
                          <span className="e-r">
                            <a
                              title="View"
                              href={
                                "exceptions?pid=" +
                                dashoardDataFilter.ProgramID +
                                "&qid=" +
                                Item.PID +
                                "&exsid=2"
                              }
                            >
                              {Item.RejectedExceptionCount > 0 && (
                                <>{Item.RejectedExceptionCount}</>
                              )}
                            </a>
                          </span>
                        </div>
                      </div>
                      {/* <div className="q-status">
                            <span>Status</span>
                            <span>Completed</span>
                          </div> */}
                    </div>
                  )}
                </div>
              ))}
          </div>

          {tabFilterObject.View == 1 && (
            <div>
              <div className="db-grid fr-12">
                <div className="db-grid-boxes">
                  <div className="db-grid-head">
                    <span>Funds available vs Achievement</span>
                    {/* <a className="btn-export">
                      <img src="images/export-b.svg" width="18" height="18" />
                    </a> */}
                  </div>

                  <div className="grid-box-pad no-padding pad-all10">
                    {LoadChart3 &&
                      GROUPED_BAR_CHART_DATA_Stock_Mena.length > 0 &&
                      loadGraph && (
                        <GroupedStackedChart
                          data={GROUPED_BAR_CHART_DATA_Stock_Mena}
                          PercentageSign={"$"}
                          colorsForBars={colorsForBars}
                          YoYGrowth={[]}
                          lineData={[]}
                          marginbottom={20}
                          showLegends={true}
                        />
                      )}
                  </div>
                </div>
                <div className="db-grid-boxes">
                  <div className="db-grid-head pb-0">
                    Funds available vs Achievement - Criteria Level
                  </div>
                  <div className="grid-box-pad pad-all10">
                    {loadGraph &&
                      BarChartDataWithLine &&
                      BarChartDataWithLine.length > 0 && (
                        <BarChartWithLine
                          data={BarChartDataWithLine}
                          PercentageSign={""}
                          legendsHOB={Legends3}
                          lineData={[]}
                          colorsForBars={colorsForBars}
                          average={[]}
                          YoYGrowth={[]}
                          CurrencySign={"$"}
                          Height={350}
                          MarginLeft={85}
                        />
                      )}
                  </div>
                </div>
              </div>
              <div
                className={isSingleImporter == false ? "db-grid" : "db-grid"}
              >
                {isSingleImporter == false && (
                  <div className="db-grid-boxes">
                    <div className="db-grid-head pb-0">
                      Funds available vs Achievement - Importer level - FY{" "}
                      {programList &&
                        programList.map((item: any, index: any) =>
                          item.PID == dashoardDataFilter.ProgramID
                            ? item.Name
                            : ""
                        )}{" "}
                      -{" "}
                      {dashoardDataFilter.QuarterID > 0 &&
                        quarterList &&
                        quarterList.map((item: any, index: any) =>
                          item.PID == dashoardDataFilter.QuarterID
                            ? item.Name
                            : ""
                        )}
                      {dashoardDataFilter.QuarterID == 0 && <>YTD</>}
                    </div>
                    <div className="grid-box-pad pad-all10">
                      <BarChartWithXValuesRotate
                        data={BarChartDATA2}
                        PercentageSign={""}
                        legendsHOB={Legends2}
                        colorsForBars={colorsForBars}
                        average={[]}
                        YoYGrowth={[]}
                        CurrencySign={"$"}
                        Height={600}
                        MarginLeft={85}
                      />
                    </div>
                  </div>
                )}
              </div>
            </div>
          )}

          {tabFilterObject.View == 0 && (
            <>
              <div
                className="flex-title re-accord mt--10"
                onClick={() => setPayOutHistoryAccord(!payOutHistoryAccord)}
              >
                <a className="a-accord">
                  <span>PAY-OUT HISTORY</span>
                  <img
                    src="/images/expand.svg"
                    className={payOutHistoryAccord ? "rotate-180" : ""}
                    width="20px"
                    height="37px"
                  />
                </a>
              </div>

              {payOutHistoryAccord && (
                <div className="db-grid-boxes">
                  <div className="db-grid-head pb-0">
                    <div className="Legend-main3">
                      <div className="leg-item">
                        <span className="OrangeClass"></span>
                        <p>Conditional hold</p>
                      </div>
                    </div>
                    <a
                      className="btn-export"
                      onClick={() =>
                        DownloadClientsDataInExcel(
                          "tblPayOutHistory",
                          "Pay-Out History"
                        )
                      }
                    >
                      <img src="images/export-b.svg" width="18" height="18" />
                    </a>
                  </div>
                  <div className="section-table grid-box-pad no-border ib-db-table pad-all10 table-pay-history">
                    <table
                      id="tblPayOutHistory"
                      className="part-head trend-table fixed-table"
                    >
                      <thead>
                        <tr>
                          <th></th>
                          <th></th>
                          <th colSpan={3}>Q1</th>
                          <th colSpan={3}>Q2</th>
                          <th colSpan={3}>Q3</th>
                          <th colSpan={3}>Q4</th>
                          <th colSpan={3}>Total</th>
                        </tr>
                        <tr>
                          <th>Market</th>
                          <th>Importer</th>
                          {payOutTableData.Header &&
                            payOutTableData.Header.map(
                              (Item: any, index: any) => (
                                <React.Fragment key={index}>
                                  <th>{Item.FundAvailable}</th>
                                  <th>{Item.AchievedPercentage}</th>
                                  <th>{Item.AchievedUSD}</th>
                                </React.Fragment>
                              )
                            )}
                        </tr>
                      </thead>
                      <tbody>
                        {payOutTableData.GridData &&
                          payOutTableData.GridData.map(
                            (item: any, index: any) => (
                              <React.Fragment key={index + "payOutTableData"}>
                                <tr className={item.Market == 'zzzz MENA Total'?'JLRBold':''}>
                                  <td>{item.Market != 'zzzz MENA Total' && <> {item.Market}</>}</td>
                                  <td>{item.Importer}</td>
                                  <td>
                                    {item.Q1FundAvailable.toLocaleString(
                                      "en-US",
                                      {
                                        style: "currency",
                                        currency: "USD",
                                        maximumFractionDigits: 0,
                                      }
                                    )}
                                  </td>
                                  <td className={item.Q1ShowYellowColor}>
                                    {item.Q1AchievedPercentage.toFixed(2) + "%"}
                                  </td>
                                  <td>
                                    {item.Q1AchievedUSD.toLocaleString(
                                      "en-US",
                                      {
                                        style: "currency",
                                        currency: "USD",
                                        maximumFractionDigits: 0,
                                      }
                                    )}
                                  </td>

                                  <td>
                                    {item.Q2FundAvailable.toLocaleString(
                                      "en-US",
                                      {
                                        style: "currency",
                                        currency: "USD",
                                        maximumFractionDigits: 0,
                                      }
                                    )}
                                  </td>
                                  <td className={item.Q2ShowYellowColor}>
                                    {item.Q2AchievedPercentage.toFixed(2) + "%"}
                                  </td>
                                  <td>
                                    {item.Q2AchievedUSD.toLocaleString(
                                      "en-US",
                                      {
                                        style: "currency",
                                        currency: "USD",
                                        maximumFractionDigits: 0,
                                      }
                                    )}
                                  </td>

                                  <td>
                                    {item.Q3FundAvailable.toLocaleString(
                                      "en-US",
                                      {
                                        style: "currency",
                                        currency: "USD",
                                        maximumFractionDigits: 0,
                                      }
                                    )}
                                  </td>
                                  <td className={item.Q3ShowYellowColor}>
                                    {item.Q3AchievedPercentage.toFixed(2) + "%"}
                                  </td>
                                  <td>
                                    {item.Q3AchievedUSD.toLocaleString(
                                      "en-US",
                                      {
                                        style: "currency",
                                        currency: "USD",
                                        maximumFractionDigits: 0,
                                      }
                                    )}
                                  </td>

                                  <td>
                                    {item.Q4FundAvailable.toLocaleString(
                                      "en-US",
                                      {
                                        style: "currency",
                                        currency: "USD",
                                        maximumFractionDigits: 0,
                                      }
                                    )}
                                  </td>
                                  <td className={item.Q4ShowYellowColor}>
                                    {item.Q4AchievedPercentage.toFixed(2) + "%"}
                                  </td>
                                  <td>
                                    {item.Q4AchievedUSD.toLocaleString(
                                      "en-US",
                                      {
                                        style: "currency",
                                        currency: "USD",
                                        maximumFractionDigits: 0,
                                      }
                                    )}
                                  </td>

                                  <td>
                                    {item.FinalFundAvailable.toLocaleString(
                                      "en-US",
                                      {
                                        style: "currency",
                                        currency: "USD",
                                        maximumFractionDigits: 0,
                                      }
                                    )}
                                  </td>
                                  <td>
                                    {item.FinalAchievedPercentage.toFixed(2) +
                                      "%"}
                                  </td>
                                  <td>
                                    {item.FinalAchievedUSD.toLocaleString(
                                      "en-US",
                                      {
                                        style: "currency",
                                        currency: "USD",
                                        maximumFractionDigits: 0,
                                      }
                                    )}
                                  </td>
                                </tr>
                              </React.Fragment>
                            )
                          )}
                      </tbody>
                    </table>
                  </div>
                </div>
              )}

              <div
                className="flex-title re-accord mt--5"
                onClick={() =>
                  setPayOutPerCriteriaAccord(!payOutPerCriteriaAccord)
                }
              >
                <a className="a-accord">
                  <span>PAY-OUT PER CRITERIA</span>
                  <img
                    src="/images/expand.svg"
                    className={payOutPerCriteriaAccord ? "rotate-180" : ""}
                    width="20px"
                    height="37px"
                  />
                </a>
              </div>

              {payOutPerCriteriaAccord && (
                <div className="db-grid mt--0">
                  <div className="db-grid-boxes overflow-scroll-popc">
                    <div className="db-grid-head less-space">
                      <span></span>
                      <a
                        className="btn-export"
                        onClick={() =>
                          DownloadClientsDataInExcel(
                            "tblIBBCriteriaProgram",
                            "Pay-Out Criteria"
                          )
                        }
                      >
                        <img src="images/export-b.svg" width="18" height="18" />
                      </a>
                    </div>
                    {dashboardData && dashboardData[2] && (
                      <div className="section-table grid-box-pad no-border pad-all10 table-popc">
                        <table
                          className="part-head trend-table"
                          id="tblIBBCriteriaProgram"
                        >
                          <thead>
                            <tr>
                              <th></th>
                              <th></th>
                              {dashboardData[1] &&
                                dashboardData[1].map(
                                  (item: any, index: any) => (
                                    <React.Fragment
                                      key={"sectionheadinga" + index}
                                    >
                                      <th colSpan={4}>
                                        <div className="flex-items justify-center">
                                          {item.IBBProgramSectionName}
                                        </div>
                                      </th>
                                    </React.Fragment>
                                  )
                                )}
                            </tr>
                            <tr>
                              <th>Market</th>
                              <th>Importer</th>
                              {dashboardData[1] &&
                                dashboardData[1].map(
                                  (item: any, index: any) => (
                                    <React.Fragment
                                      key={"sectionheadingb" + index}
                                    >
                                      <th>Funds Available</th>
                                      <th>$ Final Achievment</th>
                                      <th>$ Non achieved</th>
                                      <th>% Final Achievment</th>
                                    </React.Fragment>
                                  )
                                )}
                            </tr>
                          </thead>
                          <tbody>
                            <>
                              {payoutPerCriteriaData &&
                                payoutPerCriteriaData.map(
                                  (item: any, index: any) => (
                                    <React.Fragment
                                      key={"ReEarnableCount" + index}
                                    >
                                      <tr>
                                        <td>{item.MarketName}</td>
                                        <td>{item.DealerName}</td>

                                        {dashboardData[1] &&
                                          dashboardData[1].map(
                                            (
                                              sectionitem: any,
                                              sectionindex: any
                                            ) => (
                                              <React.Fragment
                                                key={
                                                  "index" + index + sectionindex
                                                }
                                              >
                                                <>
                                                  <td>
                                                    {item[
                                                      sectionitem.IBBProgramSectionName +
                                                        "FundsAvailable"
                                                    ]?.toLocaleString("en-US", {
                                                      style: "currency",
                                                      currency: "USD",
                                                      maximumFractionDigits: 0,
                                                    })}
                                                  </td>

                                                  <td>
                                                    {item[
                                                      sectionitem.IBBProgramSectionName +
                                                        "FinalAchievment"
                                                    ]?.toLocaleString("en-US", {
                                                      style: "currency",
                                                      currency: "USD",
                                                      maximumFractionDigits: 0,
                                                    })}
                                                  </td>
                                                  <td>
                                                    {item[
                                                      sectionitem.IBBProgramSectionName +
                                                        "NonAchieved"
                                                    ]?.toLocaleString("en-US", {
                                                      style: "currency",
                                                      currency: "USD",
                                                      maximumFractionDigits: 0,
                                                    })}
                                                  </td>
                                                  <td>
                                                    {item[
                                                      sectionitem.IBBProgramSectionName +
                                                        "PerFinalAchievment"
                                                    ]?.toLocaleString("en-US", {
                                                      minimumFractionDigits: 2,
                                                      maximumFractionDigits: 2,
                                                    }) + "%"}
                                                  </td>
                                                </>
                                              </React.Fragment>
                                            )
                                          )}
                                      </tr>
                                    </React.Fragment>
                                  )
                                )}
                              {payoutPerCriteriaData && (
                                <React.Fragment key={5555555}>
                                  <tr className="JLRBold">
                                    <td></td>
                                    <td>MENA Total</td>
                                    {dashboardData[1] &&
                                      dashboardData[1].map(
                                        (
                                          sectionitem: any,
                                          sectionindex: any
                                        ) => (
                                          <React.Fragment
                                            key={"index2222222" + sectionindex}
                                          >
                                            <>
                                              <td>
                                                {payoutPerCriteriaData
                                                  .reduce(
                                                    (acc: any, item: any) =>
                                                      acc +
                                                      item[
                                                        sectionitem.IBBProgramSectionName +
                                                          "FundsAvailable"
                                                      ],
                                                    0
                                                  )
                                                  ?.toLocaleString("en-US", {
                                                    style: "currency",
                                                    currency: "USD",
                                                    maximumFractionDigits: 0,
                                                  })}{" "}
                                              </td>
                                              <td>
                                                {payoutPerCriteriaData
                                                  .reduce(
                                                    (acc: any, item: any) =>
                                                      acc +
                                                      item[
                                                        sectionitem.IBBProgramSectionName +
                                                          "FinalAchievment"
                                                      ],
                                                    0
                                                  )
                                                  ?.toLocaleString("en-US", {
                                                    style: "currency",
                                                    currency: "USD",
                                                    maximumFractionDigits: 0,
                                                  })}{" "}
                                              </td>
                                              <td>
                                                {payoutPerCriteriaData
                                                  .reduce(
                                                    (acc: any, item: any) =>
                                                      acc +
                                                      item[
                                                        sectionitem.IBBProgramSectionName +
                                                          "NonAchieved"
                                                      ],
                                                    0
                                                  )
                                                  ?.toLocaleString("en-US", {
                                                    style: "currency",
                                                    currency: "USD",
                                                    maximumFractionDigits: 0,
                                                  })}{" "}
                                              </td>
                                              <td>
                                                {(
                                                  (payoutPerCriteriaData.reduce(
                                                    (acc: any, item: any) =>
                                                      acc +
                                                      item[
                                                        sectionitem.IBBProgramSectionName +
                                                          "FinalAchievment"
                                                      ],
                                                    0
                                                  ) /
                                                    payoutPerCriteriaData.reduce(
                                                      (acc: any, item: any) =>
                                                        acc +
                                                        item[
                                                          sectionitem.IBBProgramSectionName +
                                                            "FundsAvailable"
                                                        ],
                                                      0
                                                    ) || 1) * 100
                                                )?.toLocaleString("en-US", {
                                                  minimumFractionDigits: 2,
                                                  maximumFractionDigits: 2,
                                                })}
                                                {"%"}
                                              </td>
                                            </>
                                          </React.Fragment>
                                        )
                                      )}
                                  </tr>
                                </React.Fragment>
                              )}
                            </>
                          </tbody>
                        </table>
                      </div>
                    )}
                  </div>
                  <div className="db-grid-boxes grid-boxes-sm">
                    <div className="db-grid-head less-space">
                      <span></span>
                      <a
                        className="btn-export"
                        onClick={() =>
                          DownloadClientsDataInExcel(
                            "tblPayOutCriteria",
                            "Pay-Out Criteria"
                          )
                        }
                      >
                        <img src="images/export-b.svg" width="18" height="18" />
                      </a>
                    </div>
                    <div className="section-table grid-box-pad no-border pad-all10">
                      <table
                        id="tblPayOutCriteria"
                        className="part-head trend-table fixed-table"
                      >
                        <thead>
                          <tr>
                            <th className="trans-back-c">Criteria</th>
                            <th>Funds available (USD)</th>
                            <th>Achievement (USD)</th>
                            <th>Achievement %</th>
                          </tr>
                        </thead>
                        <tbody>
                          {dashboardData[1] &&
                            dashboardData[1].map((item: any, index: any) => (
                              <React.Fragment key={index + "Criteria-Year"}>
                                <tr>
                                  <td>{item.IBBProgramSectionName}</td>
                                  <td>
                                    {item.POT.toLocaleString("en-US", {
                                      style: "currency",
                                      currency: "USD",
                                      maximumFractionDigits: 0,
                                    })}
                                  </td>
                                  <td>
                                    {item.FinalPayout.toLocaleString("en-US", {
                                      style: "currency",
                                      currency: "USD",
                                      maximumFractionDigits: 0,
                                    })}
                                  </td>
                                  <td>
                                    {item.FinalPayoutPercentage.toFixed(2) +
                                      "%"}
                                  </td>
                                </tr>
                              </React.Fragment>
                            ))}
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
              )}

              <div
                className="flex-title re-accord mt--5"
                onClick={() =>
                  setPayOutTARGETSPerCriteriaAccord(
                    !payOutTARGETSPerCriteriaAccord
                  )
                }
              >
                <a className="a-accord">
                  <span>
                    PAY-OUT % TARGETS VS ACTUALS PER CRITERIA{" "}
                    {/* {isSingleImporter == false && <>(All Importers)</>}
                    {isSingleImporter == true && <>(Targets &amp; Actions)</>} */}
                  </span>
                  <img
                    src="/images/expand.svg"
                    className={
                      payOutTARGETSPerCriteriaAccord ? "rotate-180" : ""
                    }
                    width="20px"
                    height="37px"
                  />
                </a>
              </div>
              {payOutTARGETSPerCriteriaAccord && (
                <div className="section-table no-border all-imp-table pad-all0 db-grid fr-1--3-1 tables-loop">
                  {dashboardData[3] &&
                    dashboardData[3].map((item: any, index: any) => (
                      <React.Fragment key={index + "AllYear"}>
                        <div className="db-grid-boxes">
                          <div className="db-grid-head less-space">
                            <span></span>
                            <a
                              className="btn-export"
                              onClick={() =>
                                DownloadClientsDataInExcel(
                                  "tblCPPSPNV" + item.IBBProgramSectionName,
                                  "PAY-OUT % - " + item.IBBProgramSectionName
                                )
                              }
                            >
                              <img
                                src="images/export-b.svg"
                                width="18"
                                height="18"
                              />
                            </a>
                          </div>
                          <div className="grid-box-pad pad-all10">
                            <table
                              className="part-head trend-table fixed-table"
                              id={"tblCPPSPNV" + item.IBBProgramSectionName}
                            >
                              <thead>
                                {item.QuestionType == 4 ? (
                                  <tr>
                                    <th>{item.IBBProgramSectionName}</th>
                                    <th>
                                      Target{" "}
                                      {item.ActualValueFormat == 4
                                        ? "(USD)"
                                        : item.ActualValueFormat == 2
                                        ? "(%)"
                                        : "(Units)"}
                                    </th>
                                    <th>
                                      Order Placement Actual{" "}
                                      {item.ActualValueFormat == 4
                                        ? "(USD)"
                                        : item.ActualValueFormat == 2
                                        ? "(%)"
                                        : "(Units)"}
                                    </th>
                                    <th>
                                      Invoicing Actual{" "}
                                      {item.ActualValueFormat == 4
                                        ? "(USD)"
                                        : item.ActualValueFormat == 2
                                        ? "(%)"
                                        : "(Units)"}
                                    </th>

                                    {isSingleImporter ? (
                                      <>
                                        <th>Order Placement % </th>
                                        <th>Invoicing % </th>
                                        <th>Achievement </th>
                                        <th>Exception Applied? </th>
                                        <th>Conditional Payment Hold </th>
                                      </>
                                    ) : (
                                      <th>Target vs Invoicing % </th>
                                    )}
                                  </tr>
                                ) : (
                                  <tr>
                                    <th>{item.IBBProgramSectionName}</th>
                                    <th>
                                      Target{" "}
                                      {item.ActualValueFormat == 4
                                        ? "(USD)"
                                        : item.ActualValueFormat == 2
                                        ? "(%)"
                                        : "(Units)"}
                                    </th>
                                    <th>
                                      Actual{" "}
                                      {item.ActualValueFormat == 4
                                        ? "(USD)"
                                        : item.ActualValueFormat == 2
                                        ? "(%)"
                                        : "(Units)"}
                                    </th>
                                    <th>Target vs Actual % </th>
                                    {isSingleImporter ? (
                                      <>
                                        <th>Achievement </th>
                                        <th>Exception Applied? </th>
                                        <th>Conditional Payment Hold </th>
                                      </>
                                    ) : (
                                      <></>
                                    )}
                                  </tr>
                                )}
                              </thead>
                              <tbody>
                                {dashboardData[4] &&
                                  dashboardData[4].map(
                                    (itemInner: any, index2: any) => (
                                      <React.Fragment
                                        key={index2 + "InnerItem"}
                                      >
                                        {itemInner.IBBProgramSectionID ==
                                          item.IBBProgramSectionID &&
                                          (item.QuestionType == 4 ? (
                                            <tr>
                                              <td>{itemInner.CriteriaName}</td>
                                              <td>
                                                {itemInner.Target1?.toLocaleString(
                                                  undefined,
                                                  {
                                                    maximumFractionDigits: 0,
                                                  }
                                                )}
                                              </td>
                                              <td>
                                                {itemInner.Actual1?.toLocaleString(
                                                  undefined,
                                                  {
                                                    maximumFractionDigits: 0,
                                                  }
                                                )}
                                              </td>
                                              <td>
                                                {itemInner.Actual2?.toLocaleString(
                                                  undefined,
                                                  {
                                                    maximumFractionDigits: 0,
                                                  }
                                                )}
                                              </td>
                                              {isSingleImporter ? (
                                                <>
                                                  <td>
                                                    {itemInner.Actual1Percentage?.toLocaleString(
                                                      undefined,
                                                      {
                                                        minimumFractionDigits: 2,
                                                        maximumFractionDigits: 2,
                                                      }
                                                    )}
                                                    %
                                                  </td>
                                                  <td>
                                                    {itemInner.Actual2Percentage?.toLocaleString(
                                                      undefined,
                                                      {
                                                        minimumFractionDigits: 2,
                                                        maximumFractionDigits: 2,
                                                      }
                                                    )}
                                                    %
                                                  </td>
                                                  <td
                                                    className={
                                                      itemInner.Achievement == 1
                                                        ? "Green"
                                                        : itemInner.Achievement ==
                                                          0
                                                        ? "Red"
                                                        : "Grey"
                                                    }
                                                  >
                                                    {itemInner.Achievement == 1
                                                      ? "Yes"
                                                      : itemInner.Achievement ==
                                                        0
                                                      ? "No"
                                                      : "N/A"}{" "}
                                                  </td>
                                                  <td
                                                    className={
                                                      itemInner.ExceptionApplied ==
                                                      1
                                                        ? "Green"
                                                        : itemInner.ExceptionApplied ==
                                                          0
                                                        ? "Red"
                                                        : "Grey"
                                                    }
                                                  >
                                                    {itemInner.ExceptionApplied ==
                                                    1
                                                      ? "Yes"
                                                      : itemInner.ExceptionApplied ==
                                                        0
                                                      ? "No"
                                                      : "N/A"}{" "}
                                                  </td>
                                                  <td
                                                    className={
                                                      itemInner.ConditionalPaymentHold ==
                                                      1
                                                        ? "Green"
                                                        : itemInner.ConditionalPaymentHold ==
                                                          0
                                                        ? "Red"
                                                        : "Grey"
                                                    }
                                                  >
                                                    {itemInner.ConditionalPaymentHold ==
                                                    1
                                                      ? "Yes"
                                                      : itemInner.ConditionalPaymentHold ==
                                                        0
                                                      ? "No"
                                                      : "N/A"}{" "}
                                                  </td>
                                                </>
                                              ) : (
                                                <td>
                                                  {itemInner.Actual2Percentage?.toLocaleString(
                                                    undefined,
                                                    {
                                                      minimumFractionDigits: 2,
                                                      maximumFractionDigits: 2,
                                                    }
                                                  )}
                                                  %
                                                </td>
                                              )}
                                            </tr>
                                          ) : (
                                            <tr>
                                              <td>{itemInner.CriteriaName}</td>
                                              {item.ActualValueFormat == 2 && (
                                                <>
                                                  <td>
                                                    {itemInner.Target1?.toLocaleString(
                                                      undefined,
                                                      {
                                                        minimumFractionDigits: 2,
                                                        maximumFractionDigits: 2,
                                                      }
                                                    )}
                                                    %
                                                  </td>
                                                  <td>
                                                    {itemInner.Actual1?.toLocaleString(
                                                      undefined,
                                                      {
                                                        minimumFractionDigits: 2,
                                                        maximumFractionDigits: 2,
                                                      }
                                                    )}
                                                    %
                                                  </td>
                                                </>
                                              )}
                                              {item.ActualValueFormat != 2 && (
                                                <>
                                                  <td>
                                                    {itemInner.Target1?.toLocaleString(
                                                      undefined,
                                                      {
                                                        minimumFractionDigits: 0,
                                                        maximumFractionDigits: 0,
                                                      }
                                                    )}
                                                  </td>
                                                  <td>
                                                    {itemInner.Actual1?.toLocaleString(
                                                      undefined,
                                                      {
                                                        minimumFractionDigits: 0,
                                                        maximumFractionDigits: 0,
                                                      }
                                                    )}
                                                  </td>
                                                </>
                                              )}
                                              <td>
                                                {itemInner.Actual1Percentage?.toLocaleString(
                                                  undefined,
                                                  {
                                                    minimumFractionDigits: 2,
                                                    maximumFractionDigits: 2,
                                                  }
                                                )}
                                                %
                                              </td>
                                              {isSingleImporter ? (
                                                <>
                                                  <td
                                                    className={
                                                      itemInner.Achievement == 1
                                                        ? "Green"
                                                        : itemInner.Achievement ==
                                                          0
                                                        ? "Red"
                                                        : "Grey"
                                                    }
                                                  >
                                                    {itemInner.Achievement == 1
                                                      ? "Yes"
                                                      : itemInner.Achievement ==
                                                        0
                                                      ? "No"
                                                      : "N/A"}{" "}
                                                  </td>
                                                  <td
                                                    className={
                                                      itemInner.ExceptionApplied ==
                                                      1
                                                        ? "Green"
                                                        : itemInner.ExceptionApplied ==
                                                          0
                                                        ? "Red"
                                                        : "Grey"
                                                    }
                                                  >
                                                    {itemInner.ExceptionApplied ==
                                                    1
                                                      ? "Yes"
                                                      : itemInner.ExceptionApplied ==
                                                        0
                                                      ? "No"
                                                      : "N/A"}{" "}
                                                  </td>
                                                  <td
                                                    className={
                                                      itemInner.ConditionalPaymentHold ==
                                                      1
                                                        ? "Green"
                                                        : itemInner.ConditionalPaymentHold ==
                                                          0
                                                        ? "Red"
                                                        : "Grey"
                                                    }
                                                  >
                                                    {itemInner.ConditionalPaymentHold ==
                                                    1
                                                      ? "Yes"
                                                      : itemInner.ConditionalPaymentHold ==
                                                        0
                                                      ? "No"
                                                      : "N/A"}{" "}
                                                  </td>
                                                </>
                                              ) : (
                                                <></>
                                              )}
                                            </tr>
                                          ))}
                                      </React.Fragment>
                                    )
                                  )}
                              </tbody>
                            </table>
                          </div>
                        </div>
                      </React.Fragment>
                    ))}
                </div>
              )}
            </>
          )}
        </div>
      </div>
    </>
  );
}
